<template>
  <div class="forget-form-container">
    <div class="forget-form">
      <div class="forget-container">
        <div class="title">队伍信息</div>
        <div class="content">
          <label>队伍名称</label>
          <p>{{ teaminfo['队名'] }}</p>
          <label>参赛项目</label>
          <p>{{ teaminfo['项目'] }}</p>
          <label>限制人数</label>
          <p>5</p>
          <p align="center">
            <el-button type="primary" size="small" @click="insert()"
              >加入队伍</el-button
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import _ from 'lodash'
import * as constants from '../../constants'
import * as storage from '../../utils/storage'
import UserModel from '../../models/user'

export default {
  name: 'Jointeam',
  data() {
    return {
      token: '',
      oid: '',
      teaminfo: {},
      loginInfo: null,
    }
  },

  methods: {
    async insert() {
      const that = this
      if (!this.loginInfo) {
        let loginInfo = await UserModel.wxLogin(
          this.teaminfo.gameId,
          this.oid,
          that
        )
        this.loginInfo = loginInfo
      }
      if (this.loginInfo.submitted === 1) {
        this.$confirm(
          '你已经提交了报名，若需要加入队伍，将为你取消提交并加入队伍，是否继续？',
          '提示'
        )
          .then(async () => {
            let info = await UserModel.insertTeam(this.token)
            if (info.errNo === 0) {
              this.$message.success('加入队伍成功！')
              let loginInfo = await UserModel.wxLogin(
                this.teaminfo.gameId,
                this.oid,
                that
              )
              storage.setItem(constants.GLOBAL_CONFIG, loginInfo)
              this.$router.replace(`/page/${loginInfo.pageInfo[0].pageId}`)
            } else {
              this.$message.error(info.errMsg)
            }
          })
          .catch(() => {})
      } else {
        let info = await UserModel.insertTeam(this.token)
        if (info.errNo === 0) {
          this.$message.success('加入队伍成功！')
          if (this.loginInfo) {
            storage.setItem(constants.GLOBAL_CONFIG, this.loginInfo)
            this.$router.replace(`/page/${this.loginInfo.pageInfo[0].pageId}`)
          }
        } else {
          this.$alert(info.errMsg, '提示', {
            type: 'error',
            showClose: false,
            confirmButtonText: '确定',
            callback: (action) => {
              if (this.loginInfo) {
                storage.setItem(constants.GLOBAL_CONFIG, this.loginInfo)
                this.$router.replace(
                  `/page/${this.loginInfo.pageInfo[0].pageId}`
                )
              }
            },
          })
          // this.$message.error(info.errMsg)
        }
      }
    },
  },

  async mounted() {
    const router = this.$router
    const { token, oid } = router.history.current.query
    this.token = token
    this.oid = oid
    let data = await UserModel.getTeam(token)
    if (data.errNo === 0) {
      this.teaminfo = data.payload
    } else {
      throw data.errMsg
    }
  },
}
</script>

<style lang="stylus" scoped>
.forget-form-container {
  height: 100%;

  .forget-form {
    min-height: calc(100% - 3em);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .forget-container {
    width: 41%;
    min-height: 320px;
    border: 2px solid gray;
    background-color: #fff;
  }

  .title {
    line-height: 44px;
    text-align: center;
    font-size: 22px;
    margin-bottom: 20px;
    border-bottom: 2px solid gray;
  }

  .content {
    padding: 0 8px;
    margin-bottom: 10px;
    font-size: 18px;

    label {
      color: #666;
    }

    p {
      color: #000;
      margin: 15px 0;

      button {
        width: 120px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .forget-form-container {
    .forget-container {
      width: 95%;
    }
  }
}
</style>
